import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Business Ownership initial values
export const businessOwnershipInitialValues = {
  ownershipType: "",
  ownershipPercentage: "",
  countryOfRegistration: "",
  businessType: "",
  valuationSource: "",
  estimatedCurrentValue: "",
  equityType: "",
}

// Business Ownership validation schema
export const businessOwnershipValidationSchema = Yup.object().shape({
  name: Yup.string().required("Business Name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Investment/Purchase amount is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"),
  ownershipType: Yup.string().required("Ownership Type is required"),
  ownershipPercentage: Yup.number()
    .typeError("Must be a number")
    .required("Ownership Percentage is required")
    .min(0.01, "Must be greater than 0")
    .max(100, "Cannot exceed 100%"),
  // countryOfRegistration: Yup.string().required("Country of Registration is required"),
  businessType: Yup.string().required("Business Type is required"),
  estimatedCurrentValue: Yup.number()
    .typeError("Must be a positive number")
    .required("Estimated Current Value is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  valuationSource: Yup.string()
    .matches(
      /^[A-Za-z]+(?: [A-Za-z]+)*$/,
      "Only alphabets allowed. No numbers or special characters. No space at start or end."
    ),
})

/**
 * Business Ownership Form - Field-only component for AddAssets.js
 * This renders only the business-ownership-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const BusinessOwnershipForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="business-ownership"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default BusinessOwnershipForm
